var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"global-spinner"},[_c('v-progress-circular',{staticClass:"color-bluecomfortlife",attrs:{"indeterminate":"","size":50}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }